<template>
  <div>
    <b-badge :variant="variant(status)" v-b-popover.hover=hover>
      {{ status | titleize }}
    </b-badge>
  </div>
</template>

<script>
export default {
  props: {
    websiteOrder: { type: Object, required: true },
  },
  computed: {
    status() {
      return this.websiteOrder.status
    },
    hover() {
      return `
        Fulfillment: ${this.websiteOrder.fulfillmentStatus}
        Payment: ${this.websiteOrder.paymentStatus}
      `
    }
  },
  methods: {
    variant(status) {
      if (status == 'authorized' || status == 'pending' || status == 'null' || status == 'unfulfilled' || status == 'invoice_sent') {
        return 'secondary'
      } else if (status == 'partially_paid' || status == 'partial' || status == 'open') {
        return 'info'
      } else if (status == 'voided') {
        return 'dark'
      } else if (status == 'canceled' || status == 'refunded' || status == 'partially_refunded' || status == 'restocked') {
        return 'danger'
      } else if (status == 'charged' || status == 'shipped' || status == 'partially_shipped' || status == 'charged_and_partially_shipped' || status == 'quote') {
        return 'warning'
      } else if (status == 'paid' || status == 'fulfilled' || status == 'completed') {
        return 'success'
      }
      return 'dark'
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/WebStatus.vue